import { useRef } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import registrationImg from "../../../assets/images/registration-img.webp";
import torImg from "../../../assets/images/tor-img.webp";
import privateImg from "../../../assets/images/privet-img.webp";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import AnimatedTitle from "../../../components/AnimatedTitle/AnimatedTitle";
import useUserStore from "../../../store/useUserStore";
import { useImageHeightStore } from "../../../store/useImagesHeight";

gsap.registerPlugin(ScrollTrigger);

const titleStyles = {
  textAlign: "center",
  fontWeight: 900,
  fontSize: { xs: "24px", sm: "36px" },
  color: "rgba(11, 25, 62, 0.15)",
  textTransform: "uppercase",
};

const TitleComponent = ({ title, isMobile }) => {
  if (typeof title === "object" && title.mobile && title.desktop) {
    if (isMobile) {
      return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
          {title.mobile.map((line, lineIndex) => (
            <Typography key={lineIndex} sx={titleStyles}>
              {line}
            </Typography>
          ))}
        </Box>
      );
    }
    return <Typography sx={titleStyles}>{title.desktop}</Typography>;
  }
  
  return <Typography sx={titleStyles}>{title}</Typography>;
};

const services = [
  {
    img: privateImg,
    title: "Terms of Use, Privacy Policy, NDA",
    subtitle: "контракт розробника",
  },
  {
    img: registrationImg,
    title: "(UA, USA, EU)",
    subtitle: "реєстрація компаній",
  },
  {
    img: torImg,
    title: {
      mobile: ["IP, GDPR,", "Blockchain law"],
      desktop: "IP, GDPR, Blockchain law",
    },
    subtitle: "підтримка в досудових конфліктах",
  },
];

export default function ServicesBlock({ scrollToRef, scrollToMobileRef }) {

  const windowInnerWidth = useUserStore((state) => state.windowInnerWidth);
  const imageHeight = useImageHeightStore((state) => state.imageHeights['main-img']);

  const imageRefs = useRef([]);
  imageRefs.current = [];

  const addToImageRefs = (el) => {
    if (el && !imageRefs.current.includes(el)) {
      imageRefs.current.push(el);
    }
  };

  useGSAP(() => {
    if(!imageHeight) return;

    imageRefs.current.forEach((el, i) => {
      const speed = 1 + i * 0.4;
      gsap.to(el, {
        y: -100 / speed,
        ease: "none",
        scrollTrigger: {
          trigger: el,
          start: "top bottom", 
          end: "bottom top", 
          scrub: true,
          invalidateOnRefresh: true,
        },
      });
    });

    return () => {
      ScrollTrigger.getAll().forEach((t) => t.kill());
      gsap.killTweensOf(imageRefs.current);
    };
  }, [imageHeight, windowInnerWidth]);

  return (
    <Box
      ref={scrollToRef}
      sx={{
        width: "100%",
        minHeight: "808px",
        padding: windowInnerWidth < 960 ? "0 20px" : "0 80px",
        display: "flex",
        justifyContent: "center",
        mt: "97px",
        "@media (min-width: 640px)": {
          mt: "233px",
        }
      }}
    >
      <Box sx={{ width: "100%", maxWidth: "1280px" }}>
        <AnimatedTitle text="Послуги" />

        <Box
          sx={{
            display: "grid",
            mt: { xs: "48px", md: "116px" },
            gap: "40px",
            gridTemplateColumns: {
              xs: "1fr",
              lg: "repeat(3, 1fr)",
            },
            justifyItems: "center",
          }}
        >
          {services.map((item, index) => (
            <Box
              key={index}
              sx={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "16px",
              }}
            >
              <Box
                component="img"
                src={item.img}
                ref={addToImageRefs}
                alt={`image ${index}`}
                sx={{
                  width: { xs: "320px", sm: "300px" },
                  height: { xs: "320px", sm: "300px" },
                  objectFit: "cover",
                }}
              />
              <Box>
                <TitleComponent title={item.title} isMobile={windowInnerWidth < 768} />
                <Typography
                  sx={{
                    textAlign: "center",
                    fontWeight: 400,
                    fontSize: { xs: "20px", sm: "24px" },
                    color: "rgba(11, 25, 62, 1)",
                  }}
                >
                  {item.subtitle}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>

        {windowInnerWidth < 1200 && (
          <AnimatedTitle
            ref={scrollToMobileRef}
            text="Як ми працюємо"
            sx={{
              mb: "24px",
              mt: "97px",
            }}
          />
        )}
      </Box>
    </Box>
  );
}
